import { Component, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { ConstantsService } from '../core/services/constants.service';
import { ImageOptimizationService } from '../core/services/image-optimization.service';

@Component({
  selector: 'app-rc',
  templateUrl: './rc.component.html',
  styleUrls: ['./rc.component.css'],
  standalone: false
})
export class RcComponent implements OnInit, AfterViewInit {
  @ViewChild('rcElement', { static: false }) rcElement!: ElementRef<HTMLElement>;

  theme!: string;

  constructor(
    private readonly constantsService: ConstantsService,
    private readonly imageOptimizationService: ImageOptimizationService
  ) {
    // Preload all theme images for better performance
    this.preloadBackgroundImages();
  }

  ngOnInit(): void {
    this.theme = this.constantsService.getCurrentSeason();
  }

  ngAfterViewInit(): void {
    // Apply optimized background image after view initialization
    setTimeout(() => {
      this.applyOptimizedBackgroundImage();
    });
  }

  /**
   * Apply optimized background image based on current theme
   */
  private applyOptimizedBackgroundImage(): void {
    if (this.rcElement && this.theme) {
      this.imageOptimizationService.applyBackgroundImage(
        this.rcElement.nativeElement,
        this.theme
      );
    }
  }

  /**
   * Preload background images for better performance
   */
  private async preloadBackgroundImages(): Promise<void> {
    try {
      const isMobile = this.imageOptimizationService.isMobileDevice();
      await this.imageOptimizationService.preloadAllThemes(isMobile);

      // Preload current theme first if available
      if (this.theme) {
        await this.imageOptimizationService.preloadImage(this.theme, isMobile);
      }
    } catch (error) {
      console.warn('Background image preloading failed:', error);
    }
  }
}
